import {
  filterMenuByPermissions,
  hasAnyPermission
} from "@src/security/permissions";

const ELECTORAL_GEOGRAPHY_EDIT_PERMISSIONS = [
  "CREATE_DEPARTMENT", "UPDATE_DEPARTMENT",
  "CREATE_ARRONDISSEMENT", "UPDATE_ARRONDISSEMENT",
  "CREATE_COMMUNE", "UPDATE_COMMUNE",
  "CREATE_SECTION", "UPDATE_SECTION",
  "CREATE_CONSTITUENCY", "UPDATE_CONSTITUENCY",
  "CREATE_VOTING_CENTER", "UPDATE_VOTING_CENTER"
];

const MENU = {
  oniRecords: {
    label:
      "app.menu.cep_records.label",

    description:
      "app.menu.cep_records.description",

    path:
      "/person",

    requires: [
      "READ_PERSON"
    ],


    options: {
      list: {
        label:
          "app.menu.actions.list",

        path:
          "/person"
      },
      ninuApplications: {
        label: "adjudication.ninuMenu",
        path: "/person/adjudications",
        requires: ["READ_PERSON"]
      }
    }
  },

  voterRegistration: {
    label:
      "menu.voter.registration",

    description:
      "menu.voter.registration.description",

    options: {
      applications: {
        label:
          "menu.voter.applications",

        path:
          "/voter-application",

        requires: [
          "SEARCH_VOTER_APPLICATION",
          "COUNT_VOTER_APPLICATION"
        ]
      },

      adjudications: {
        label: "adjudication.voterMenu",
        path: "/voter-application/adjudications",
        requires: ["READ_VOTER_APPLICATION", "SEARCH_VOTER_APPLICATION"]
      },

      records: {
        label:
          "menu.voter.records",

        path:
          "/voter",

        requires: [
          "SEARCH_VOTER",
          "COUNT_VOTER"
        ]
      },

      preliminaryRolls: {
        label:
          "voterRoll.preliminaryRolls",

        path:
          "/voter-roll/preliminary",

        requires: [
          "SEARCH_VOTER_ROLL",
          "COUNT_VOTER_ROLL"
        ]
      },

      finalRolls: {
        label:
          "voterRoll.finalRolls",

        path:
          "/voter-roll/final",

        requires: [
          "SEARCH_VOTER_ROLL",
          "COUNT_VOTER_ROLL"
        ]
      },

      maintenance: {
        label:
          "maintenance.menu",

        path:
          "/maintenance/applications",

        requires: [
          "SEARCH_VOTER_APPLICATION",
          "COUNT_VOTER_APPLICATION"
        ]
      }
    }
  },

  fieldOperators: {
    label:
      "app.menu.field_operators.label",

    description:
      "app.menu.field_operators.description",

    path:
      "/operator-account-request",

    options: {
      accountRequests: {
        label:
          "app.menu.user_account_requests.label",

        path:
          "/operator-account-request",

        requires: [
          "READ_OPERATOR_ACCOUNT_REQUEST"
        ]
      },

      accounts: {
        label:
          "app.menu.user_accounts.label",

        path:
          "/operator-user",

        requires: [
          "READ_OPERATOR_USER"
        ]
      }
    }
  },

  electoralGeography: {
    label:
      "app.menu.electoral_geography.label",

    description:
      "app.menu.electoral_geography.description",

    path:
      "/electoral-geography",

    requiresAny: [
      "READ_ELECTORAL_GEOGRAPHY",
      ...ELECTORAL_GEOGRAPHY_EDIT_PERMISSIONS
    ],

    options: {
      manage: {
        label:
          "app.menu.actions.manage",

        path:
          "/electoral-geography"
      },
      redirect: {
        label: "geo.redirect.menu",
        path: "/electoral-geography/redirect",
        requires: ["UPDATE_VOTING_CENTER"]
      }
    }
  },


  diagnostics: {
    label:
      "menu.diagnostics.label",

    description:
      "menu.diagnostics.description",

    path:
      "/diagnostics",

    requires: [
      "READ_DIAGNOSTICS",
      "COUNT_DIAGNOSTICS"
    ],

    options: {
      list: {
        label:
          "app.menu.actions.list",

        path:
          "/diagnostics"
      }
    }
  },

reporting: {
  label:
    "app.menu.reporting.label",

  description:
    "app.menu.reporting.description",

  path:
    "/reporting",

  requiresAny: [
    "READ_STATISTICAL_REPORTS",
    "READ_OPERATIONAL_REPORTS"
  ],

  options: {
    overview: {
      label:
        "app.menu.reporting.overview",

      path:
        "/reporting",

      requires: [
        "READ_STATISTICAL_REPORTS"
      ]
    },

    advanced: {
      label:
        "app.menu.reporting.advanced",

      path:
        "/reporting/advanced",

      requires: [
        "READ_STATISTICAL_REPORTS"
      ]
    },

    tablets: {
      label:
        "menu.reporting.tablets",

      path:
        "/reporting/tablets",

      requires: [
        "READ_OPERATIONAL_REPORTS"
      ]
    },

    votingCenters: {
      label:
        "app.menu.reporting.votingCenterReports",

      path:
        "/reporting/voting-centers",

      requires: [
        "READ_OPERATIONAL_REPORTS"
      ]
    }
  }
},


  developer: {
    label: "app.menu.developer.label",
    path: "/developer/api",
    requires: [
      "READ_API_DOCUMENTATION"
    ],
    options: {
      apiDocumentation: {
        label: "app.menu.developer.apiDocumentation",
        path: "/developer/api",
        requires: [
          "READ_API_DOCUMENTATION"
        ]
      }
    }
  },

  trustUsers: {
    label:
      "menu.users.label",

    description:
      "menu.users.description",

    path:
      "/__backoffice-user",

    requiresAny: [
      "SEARCH_BACKOFFICE_USER",
      "COUNT_BACKOFFICE_USER",
      "READ_BACKOFFICE_USER",
      "SEARCH_PARTNER_USER",
      "COUNT_PARTNER_USER",
      "READ_PARTNER_USER"
    ],

    options: {
      list: {
        label:
          "menu.backoffice",

        path:
          "/__backoffice-user",

        requires: [
          "SEARCH_BACKOFFICE_USER",
          "COUNT_BACKOFFICE_USER"
        ]
      },

      apiUsers: {
        label:
          "menu.api_users",
        path:
          "/__partner-users",

        requires: [
          "SEARCH_PARTNER_USER",
          "COUNT_PARTNER_USER"
        ]
      }
    }
  }
};

export const menu = (
  session
) => {
  const filtered =
    filterMenuByPermissions(
      MENU,
      session
    );

  // A viewer can open the same page but must not be offered a Manage label.
  if (filtered.electoralGeography &&
      !hasAnyPermission(session, ELECTORAL_GEOGRAPHY_EDIT_PERMISSIONS)) {
    const geography = filtered.electoralGeography;
    filtered.electoralGeography = {
      ...geography,
      options: {
        ...geography.options,
        manage: {
          ...geography.options.manage,
          label: "app.menu.actions.view"
        }
      }
    };
  }

  const {
    fieldOperators,
    trustUsers
  } = filtered;

  /*
   * If the user has access to the regular Users menu,
   * nest Field operators underneath it.
   *
   * If the user only has field-operator permissions,
   * leave Field operators as its own top-level menu.
   */
  if (
    !fieldOperators ||
    !trustUsers
  ) {
    return filtered;
  }

  const {
    fieldOperators: _fieldOperators,
    ...rest
  } = filtered;

  return {
    ...rest,

    trustUsers: {
      ...trustUsers,

      options: {
        ...trustUsers.options,

        fieldOperators
      }
    }
  };
};

export default menu;